import * as React from 'react';
import { getFillProgress } from './getFillProgress';
import { IFIOContainerProps } from '../FIOContainer';

export interface IParams {
  onChange: IFIOContainerProps['onChange'];
  inputValue: string;
}

export const useInputValueSubscribe = (params: IParams) => {
  const { onChange, inputValue } = params;

  React.useEffect(() => {
    const inputSplitValue = inputValue.split(' ');

    const fillProgress = getFillProgress(inputSplitValue);

    onChange(inputValue, fillProgress);
  }, [onChange, inputValue]);
};
